'use strict';
angular.module('kerp-forms.forms')
  .factory(
    'LI_FCA_FORM',
    [
      'FormUI',
      'fieldDefinitionService',
      'LI_FCA_CONDITIONS',
      'lincsCareAssessmentCalculator',
      'sfSelect',
      'htmlService',
      '$window',
      'configuration',

      function (
        FormUI,
        fieldDefinitionService,
        conditions,
        careAssessmentCalculator,
        sfSelect,
        htmlService,
        $window,
        configuration
      ) {

        var enableResidentialCalcs = (configuration.featureFlags || {}).residentialCalcs;

        var constants = $window.kerpCfa.lincs.constants;

        var formUI = new FormUI();
        var nonResidential = constants.careTypes.nonResidential;

        function residentialExpenses() {
          var residentialExpenses = [];

          if (enableResidentialCalcs) {
            residentialExpenses = [
              fieldDefinitionService.groups.periodicPaymentFormFields({
                key: 'person.expenses.waterRates',
              }),

              fieldDefinitionService.groups.periodicPaymentFormFields({
                key: 'person.expenses.gas',
              }),

              fieldDefinitionService.groups.periodicPaymentFormFields({
                key: 'person.expenses.electric',
              }),

              fieldDefinitionService.groups.periodicPaymentFormFields({
                key: 'person.expenses.lifeline',
              })
            ];
          }

          return residentialExpenses;
        }

        function costOfCareItems() {
          var costOfCareItemList = [
            {
              type: 'template',
              templateUrl: 'modules/forms/scripts/services/forms/LI_CA/templates/costOfCareIntro.html'
            }
          ];

          if (enableResidentialCalcs) {
            costOfCareItemList = costOfCareItemList.concat([
              'careAssessment.showCaretypes',
              'careAssessment.selectCaretype',
            ]);
          }

          var nonResCareType = {
              type: 'section',
              htmlClass: "row",
              items: [
                {
                  type: "fieldset",
                  title: 'Non-residential',
                  htmlClass: "col-md-12",
                  items: [
                    {
                      key: 'careAssessment.nonResidential.maxContribution',
                      type: 'careAssessmentResult',
                      formTypeCode: 'LI_FCA',
                      calculator: careAssessmentCalculator,
                      careType: constants.careTypes.nonResidential,
                      title: 'Maximum non-residential care contribution'
                    },
                    {
                      type: "fieldset",
                      htmlClass: 'margin-top20 collapsible',
                      notitle: true,
                      collapse: true,
                      items: [
                        'careAssessment.nonResidential.workings'
                      ]
                    }
                  ]
                }
              ]
          };

          var careTypeFields = [nonResCareType];

          if (enableResidentialCalcs) {
            nonResCareType.items[0].condition = "model.careAssessment.showCaretypes !== 'residential'";
            careTypeFields = careTypeFields.concat([
              {
                type: 'section',
                htmlClass: "row",
                items: [
                  {
                    type: "fieldset",
                    title: "Residential Temporary",
                    htmlClass: "col-md-12",
                    condition: "model.careAssessment.showCaretypes !== 'nonResidential'",
                    items: [
                      {
                        key: 'careAssessment.temporaryResidential.maxContribution',
                        type: 'careAssessmentResult',
                        formTypeCode: 'LI_FCA',
                        calculator: careAssessmentCalculator,
                        careType: constants.careTypes.temporaryResidential,
                        title: 'Maximum temporary residential care contribution'
                      },
                      {
                        type: "fieldset",
                        htmlClass: 'margin-top20 collapsible',
                        notitle: true,
                        collapse: true,
                        items: ['careAssessment.temporaryResidential.workings']
                      }
                    ]
                  },

                  {
                    type: "fieldset",
                    title: "Residential Permanent (week 1-12)",
                    htmlClass: "col-md-12",
                    condition: "model.careAssessment.showCaretypes !== 'nonResidential'",
                    items: [
                      {
                        key: 'careAssessment.permWeek1Residential.maxContribution',
                        type: 'careAssessmentResult',
                        formTypeCode: 'LI_FCA',
                        calculator: careAssessmentCalculator,
                        careType: constants.careTypes.permWeek1Residential,
                        title: 'Maximum permanent residential care contribution'
                      },
                      {
                        type: "fieldset",
                        htmlClass: 'margin-top20 collapsible',
                        notitle: true,
                        collapse: true,
                        items: ['careAssessment.permWeek1Residential.workings']
                      }
                    ]
                  },
                  {
                    type: "fieldset",
                    title: "Residential Permanent (weeks 13+)",
                    htmlClass: "col-md-12",
                    condition: "model.careAssessment.showCaretypes !== 'nonResidential'",
                    items: [
                      {
                        key: 'careAssessment.permWeek13Residential.maxContribution',
                        type: 'careAssessmentResult',
                        formTypeCode: 'LI_FCA',
                        calculator: careAssessmentCalculator,
                        careType: constants.careTypes.permWeek13Residential,
                        title: 'Maximum permanent residential care contribution'
                      },
                      {
                        type: "fieldset",
                        htmlClass: 'margin-top20 collapsible',
                        notitle: true,
                        collapse: true,
                        items: ['careAssessment.permWeek13Residential.workings']
                      }
                    ]
                  }
                ]
              }

            ]);
          }

          costOfCareItemList = costOfCareItemList.concat(careTypeFields);
          costOfCareItemList = costOfCareItemList.concat([
            {
              type: 'template',
              templateUrl: 'modules/forms/scripts/services/forms/LI_FCA/templates/costOfCareHelp.html'
            },
            {
              key: "careAssessment.careDecision",
              title: "Care package preference",
              type: "radios",
              titleMap: {
                continue: "I want to submit this full care financial assistance application to Lincolnshire County Council and continue with an assessment of my care needs.",
                continueWithoutFinancialAssistance: "I want to continue with a care needs assessment without applying for financial assistance. I agree to pay the full costs of my care and I understand this will incur a one-off arrangement fee of £445 (<strong>Please note:</strong> The arrangement fee does not apply to <strong>residential</strong> care packages)."
              },
              description: 'Based on the calculations above please select one of these options'
            }
          ]);

          return costOfCareItemList;
        }

        formUI.getHiddenPages = function (model) {
          var withholdFinancialDetailsAndPayFullCost = model.declaration && model.declaration.provideFinancialDetails === 'payFullCost';
          var withholdFinancialDetailsAndArrangeOwnCare = model.declaration && model.declaration.provideFinancialDetails === 'arrangeMyOwn';
          var chargingExemption = model.person && model.person.details && model.person.details.chargingExemption;
          var hasChargingExemption = chargingExemption === 'exemptSection117' || chargingExemption === 'exemptCJD';

          let hiddenPages = [];

          if (withholdFinancialDetailsAndPayFullCost) {
            hiddenPages = [2, 3, 4, 5, 6, 7];
          } else if (withholdFinancialDetailsAndArrangeOwnCare || hasChargingExemption) {
            hiddenPages = [2, 3, 4, 5, 6, 7, 8];
          } else {
            hiddenPages = [];
          }

          return hiddenPages;
        };

        /**
         * Recalculate the cost of care on submission because the user could use the pagination controls to change
         * an input field (without revisiting the calculation page) before submitting
         * @param dirtyModel
         * @param cleanModel
         */
        formUI.preSubmissionHandler = function (dirtyModel, cleanModel) {
          careAssessmentCalculator.recalculate(dirtyModel, cleanModel, false);
        };


        formUI.setForm([
          {
            type: 'section',
            condition: 'model.page === 1',
            page: 1,
            htmlClass: "row",
            items: [
              {
                type: "fieldset",
                htmlClass: "col-md-12",
                items: [
                  {
                    type: 'template',
                    htmlClass: 'divTitle',
                    templateUrl: 'modules/forms/scripts/services/forms/LI_FCA/templates/cfa_animation_01_intro.html'
                  },
                  {
                    key: 'clientReference',
                    description: 'You will find your Mosaic reference number on letters or emails you have received from the Financial Assessment & Income Collection Team.',
                    validationMessage: 'Please enter a valid Mosaic reference number.'
                  }
                ]
              },
              {
                type: "fieldset",
                title: 'About you',
                htmlClass: "col-md-6",
                items: [
                  {
                    type: 'template',
                    htmlClass: 'divTitle',
                    templateUrl: 'modules/forms/scripts/services/forms/LI_FCA/templates/cfa_animation_02_about-you.html'
                  },
                  'person.details.title',
                  'person.details.firstName',
                  'person.details.lastName',
                  'person.details.nationalInsuranceNumber',
                  'person.details.dob',
                  {
                    key: 'person.details.email',
                    description: 'If you provide an email address then this will be the default method of contacting you in the future if we need more information.'
                  },
                  'person.details.phoneNumber',
                  'person.details.mobilePhoneNumber',
                  {
                    key: 'person.details.isEntitledToCarersPremium',
                    description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_FCA/templates/applicantUnderlyingCarersAllowanceDescription.html')
                  },
                  {
                    key: 'person.details.hasPartner',
                    description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_CA/templates/partnerDescription.html')
                  },
                  {
                    key: 'person.details.partnerLivesAtSameAddress',
                    condition: 'model.person.details.hasPartner',
                    description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_CA/templates/partnerSameAddress.html')
                  },

                  {
                    key: 'person.details.partnerReceivesResidentialCare',
                    condition: 'model.person.details.hasPartner'
                  },

                  {
                    key: 'person.details.partnerResidentialCareTerm',
                    condition: 'model.person.details.hasPartner && model.person.details.partnerReceivesResidentialCare'
                  },

                  {
                    key: 'person.details.partnerReceivesCare',
                    condition: 'model.person.details.hasPartner'
                  },
                  {
                    key: 'person.details.declarePartnerFinances',
                    description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_FCA/templates/jointBenefitsInformation.html'),
                    condition: 'model.person.details.hasPartner'
                  },
                  {
                    key: 'person.details.jointBenefitAgreement',
                    condition: 'model.person.details.hasPartner'
                  },
                  {
                    type: "template",
                    templateUrl: "modules/forms/scripts/services/forms/LI_FCA/templates/addressLookup.html"
                  },
                  // FIXME: these fields are already defined in the addressSuggestion directive's template, but they are not included in the submitted model unless they are repeated here
                  {
                    key: 'person.details.address.line1',
                    title: 'Address line 1',
                    type: "hidden"
                  },
                  {
                    key: 'person.details.address.line2',
                    title: 'Address line 2',
                    type: "hidden"
                  },
                  {
                    key: 'person.details.address.line3',
                    title: 'Address line 3',
                    type: "hidden"
                  },
                  {
                    key: 'person.details.address.postcode',
                    title: 'Postcode',
                    type: "hidden"
                  },
                  {
                    key: 'person.details.address.uprn',
                    title: 'Property Reference',
                    type: "hidden"
                  }
                ]
              },
              {
                type: "fieldset",
                title: 'About your partner',
                htmlClass: "col-md-6",
                items: [
                  'partner.details.title',
                  'partner.details.firstName',
                  'partner.details.lastName',
                  'partner.details.nationalInsuranceNumber',
                  'partner.details.dob',
                  'partner.details.mobilePhoneNumber',
                  {
                    key: 'partner.details.isEntitledToCarersPremium',
                    description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_FCA/templates/partnerUnderlyingCarersAllowanceDescription.html')
                  }
                ],
                condition: 'model.person.details.hasPartner'
              },
              {
                type: 'fieldset',
                title: "Declaring your financial circumstances",
                htmlClass: "col-md-12",
                items: [
                  'declaration.provideFinancialDetails'
                ]
              },
              {
                type: "fieldset",
                title: 'Care contribution exemption',
                htmlClass: "col-md-12",
                items: [
                  {
                    title: 'With respect to care contributions, are you?',
                    key: 'person.details.chargingExemption',
                    description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_CA/templates/chargingExemption.html')
                  }
                ]
              }
            ]
          },
          {
            type: 'section',
            condition: 'model.page === 2',
            page: 2,
            items: [
              {
                type: 'section',
                htmlClass: "row",
                items: [
                  {
                    type: "fieldset",
                    title: 'Your capital',
                    htmlClass: "col-md-4",
                    items: [
                      {
                        type: 'template',
                        htmlClass: 'divTitle',
                        templateUrl: 'modules/forms/scripts/services/forms/LI_FCA/templates/cfa_animation_03_capital-intro.html'
                      },
                      {
                        key: 'person.capital.hasSavingsInvestments',
                        title: 'Do you have any money or investments which are held in accounts where you are the sole named account holder?'
                      }
                    ]
                  },
                  {
                    type: "fieldset",
                    condition: 'model.person.details.hasPartner && model.person.details.declarePartnerFinances',
                    title: "Your partner's capital",
                    htmlClass: "col-md-4",
                    items: [
                      {
                        key: 'partner.capital.hasSavingsInvestments',
                        title: 'Does your partner have any money or investments which are held in accounts where they are the sole named account holder?'
                      }
                    ]
                  },
                  {
                    type: "fieldset",
                    title: "Joint capital",
                    htmlClass: "col-md-4",
                    items: [
                      {
                        key: 'joint.capital.hasSavingsInvestments',
                        title: 'Do you have any money or investments which are held in accounts where you and someone else are both named account holders?'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'template',
                templateUrl: 'modules/forms/scripts/services/forms/LI_FCA/templates/capitalDescription.html'
              },
              {
                type: 'section',
                htmlClass: "row",
                items: [
                  {
                    type: "fieldset",
                    htmlClass: "col-md-4",
                    items: [
                      {
                        condition: 'model.person.capital.hasSavingsInvestments',
                        key: 'person.capital.savingsInvestments',
                        add: "Add account",
                        title: 'Your bank / building society / post office accounts',
                        validationMessage: 'Enter details of at least one account'
                      }
                    ]
                  },
                  {
                    type: "fieldset",
                    condition: 'model.person.details.hasPartner && model.person.details.declarePartnerFinances',
                    htmlClass: "col-md-4",
                    items: [
                      {
                        condition: 'model.partner.capital.hasSavingsInvestments',
                        key: 'partner.capital.savingsInvestments',
                        add: "Add account",
                        title: "Your partner's bank / building society / post office accounts",
                        validationMessage: 'Enter details of at least one account'
                      }
                    ]
                  },
                  {
                    type: "fieldset",
                    htmlClass: "col-md-4",
                    items: [
                      {
                        condition: 'model.joint.capital.hasSavingsInvestments',
                        key: 'joint.capital.savingsInvestments',
                        add: "Add account",
                        title: 'Jointly owned bank / building society / post office accounts',
                        validationMessage: 'Enter details of at least one account'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'section',
                htmlClass: "row",
                items: [
                  {
                    type: "fieldset",
                    htmlClass: "col-md-4",
                    items: [
                      {
                        key: 'person.capital.hasBonds',
                        title: 'Are you the sole owner of any premium bonds / savings bonds / investment bonds / ISAs / trusts?',
                        description: '<strong>Please note:</strong> Any capital held in premium bonds / savings bonds / investment bonds / ISAs / trusts may be subject to further review. This could affect the amount you may need to contribute towards your care. If this is the case, the Council will contact you at a later date.'
                      },
                      {
                        condition: 'model.person.capital.hasBonds',
                        key: 'person.capital.bonds',
                        add: "Add investment",
                        title: 'Your premium bonds / savings bonds / investment bonds / ISAs / trusts',
                        validationMessage: 'Enter details of at least one investment'
                      }
                    ]
                  },
                  {
                    type: "fieldset",
                    condition: 'model.person.details.hasPartner && model.person.details.declarePartnerFinances',
                    htmlClass: "col-md-4",
                    items: [
                      {
                        key: 'partner.capital.hasBonds',
                        title: 'Is your partner the sole owner of any premium bonds / savings bonds / investment bonds / ISAs / trusts?',
                        description: '<strong>Please note:</strong> Any capital held in premium bonds / savings bonds / investment bonds / ISAs / trusts may be subject to further review. This could affect the amount you may need to contribute towards your care. If this is the case, the Council will contact you at a later date.'
                      },
                      {
                        condition: 'model.partner.capital.hasBonds',
                        key: 'partner.capital.bonds',
                        add: "Add investment",
                        title: "Your partner's premium bonds / savings bonds / investment bonds / ISAs / trusts",
                        validationMessage: 'Enter details of at least one investment'
                      }
                    ]
                  },
                  {
                    type: "fieldset",
                    htmlClass: "col-md-4",
                    items: [
                      {
                        key: 'joint.capital.hasBonds',
                        title: 'Do you and someone else jointly own any savings bonds / investment bonds / trusts?',
                        description: '<strong>Please note:</strong> Any capital held in savings bonds / investment bonds / trusts may be subject to further review. This could affect the amount you may need to contribute towards your care. If this is the case, the Council will contact you at a later date.'
                      },
                      {
                        condition: 'model.joint.capital.hasBonds',
                        key: 'joint.capital.bonds',
                        add: "Add investment",
                        title: 'Jointly owned savings bonds / investment bonds / trusts',
                        validationMessage: 'Enter details of at least one investment'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'section',
                htmlClass: "row",
                items: [
                  {
                    type: "fieldset",
                    title: 'Your stocks / shares / national saving certificates',
                    htmlClass: "col-md-4",
                    items: [
                      {
                        key: 'person.capital.hasShareholdings',
                        title: 'Are you the sole owner of any stocks / shares / national saving certificates?'
                      },
                      {
                        key: 'person.capital.shareholdings',
                        condition: 'model.person.capital.hasShareholdings',
                        add: "Add holding",
                        title: 'Your holdings',
                        validationMessage: 'Enter details of at least one shareholding'
                      }
                    ]
                  },
                  {
                    type: "fieldset",
                    condition: 'model.person.details.hasPartner && model.person.details.declarePartnerFinances',
                    title: "Your partner's stocks / shares / national saving certificates",
                    htmlClass: "col-md-4",
                    items: [
                      {
                        key: 'partner.capital.hasShareholdings',
                        title: 'Is your partner the sole owner of any stocks / shares / national saving certificates?'
                      },
                      {
                        key: 'partner.capital.shareholdings',
                        condition: 'model.partner.capital.hasShareholdings',
                        add: "Add holding",
                        title: "Your partner's holdings",
                        validationMessage: 'Enter details of at least one shareholding'
                      }
                    ]
                  },
                  {
                    type: "fieldset",
                    condition: 'model.person.details.hasPartner && model.person.details.declarePartnerFinances',
                    title: "Joint stocks / shares / national saving certificates",
                    htmlClass: "col-md-4",
                    items: [
                      {
                        key: 'joint.capital.hasShareholdings',
                        title: 'Do you and someone else jointly own any stocks / shares / national saving certificates?'
                      },
                      {
                        key: 'joint.capital.shareholdings',
                        condition: 'model.joint.capital.hasShareholdings',
                        add: "Add holding",
                        title: 'Jointly owned holdings',
                        validationMessage: 'Enter details of at least one shareholding'
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: 'section',
            condition: 'model.page === 3',
            page: 3,
            items: [
              {
                type: 'fieldset',
                title: 'Where you live',
                items: [
                  'person.details.propertyTenancy',
                  'person.details.propertyType',
                  'person.details.currentlyInCare',
                  {
                    key: 'person.details.currentCareAddress',
                    condition: 'model.person.details.currentlyInCare'
                  },
                  {
                    key: 'person.details.currentCareFees',
                    condition: 'model.person.details.currentlyInCare'
                  },
                  {
                    key: 'person.details.currentCareDateOfAdmission',
                    condition: 'model.person.details.currentlyInCare'
                  },
                  {
                    key: 'person.details.currentCareDatePaidUpTo',
                    condition: 'model.person.details.currentlyInCare'
                  },
                  {
                    key: 'person.details.propertyTenancyAdditionalDetails',
                    condition: "model.person.details.propertyTenancy === 'other'"
                  },
                  {
                    key: 'person.details.propertyRentedByApplicant',
                    condition: 'model.person.details.propertyTenancy === "rentedPrivately" || model.person.details.propertyTenancy === "councilTenant"',
                    title: 'Property you rent'
                  },
                  {
                    key: 'person.details.propertyOwnedByApplicant',
                    condition: 'model.person.details.propertyTenancy === "ownedByYou"',
                    title: 'Property you own'
                  },
                  'person.property.hasAdditionalProperties',
                  {
                    key: 'person.property.additionalProperties',
                    condition: 'model.person.property.hasAdditionalProperties',
                    add: "Add property",
                    title: 'We need to know details and value(s) of any property/properties, including land, owned and/or jointly owned by you other than your main home',
                    validationMessage: 'Enter details of at least one property'
                  },
                  {
                    key: 'peopleLivingWithYou.hasOtherPeople',
                    description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_FCA/templates/nonDependentsDescription.html')
                  },
                  {
                    key: 'peopleLivingWithYou.otherPeople',
                    condition: 'model.peopleLivingWithYou.hasOtherPeople',
                    add: "Add Person",
                    title: 'Details of other people living with you',
                    validationMessage: 'Complete all required fields for at least one person'
                  },
                  {
                    key: 'peopleLivingWithYou.hasDependentChildren',
                    description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_FCA/templates/dependentChildrenDescription.html')
                  },
                  {
                    key: 'peopleLivingWithYou.dependentChildren',
                    condition: 'model.peopleLivingWithYou.hasDependentChildren',
                    add: "Add Person",
                    title: 'Details of other people living with you',
                    validationMessage: 'Complete all required fields for at least one person'
                  },
                  {
                    key: 'person.details.hasPreviouslyOwnedProperty',
                    condition: 'model.person.details.propertyTenancy === "rentedPrivately" || model.person.details.propertyTenancy === "ownedByFamilyMember" || model.person.details.propertyTenancy === "livingWithFamilyMember" || model.person.details.propertyTenancy === "councilTenant" || model.person.details.propertyTenancy === "other"'
                  },
                  {
                    key: 'person.details.propertyPreviouslyOwned',
                    condition: 'model.person.details.hasPreviouslyOwnedProperty',
                    title: 'Property you previously owned'
                  }
                ]
              }
            ]
          },
          {
            type: 'section',
            condition: 'model.page === 4',
            page: 4,
            items: [
              {
                type: 'section',
                htmlClass: "row",
                items: [
                  {
                    type: "fieldset",
                    title: 'Your income',
                    htmlClass: "col-md-6",
                    items: [
                      {
                        type: 'template',
                        htmlClass: 'divTitle',
                        templateUrl: 'modules/forms/scripts/services/forms/LI_FCA/templates/cfa_animation_04_income-intro.html'
                      },
                      {
                        type: "help",
                        helpvalue: "<h4 class='section-title'>Your pensions</h4>"
                      },
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.retirementPensionReceived'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({
                        key: 'person.income.sources.retirementPension',
                        htmlClass: 'invisible'
                      }, {
                        htmlClass: 'invisible'
                      }),
                      {
                        key: 'person.income.hasAnnuity',
                        title: 'Are you in receipt of a pension annuity?',
                        description: 'A pension annuity is a financial product that you can buy when you retire and it pays you a guaranteed income either for a fixed period or for the rest of your life. The amount you enter should be after any deductions and taxes have been taken off. If you aren\'t sure whether your pension income is an annuity or a regular private pension you should consult the paperwork from your provider(s)'
                      },
                      {
                        key: 'person.income.annuities',
                        condition: 'model.person.income.hasAnnuity',
                        add: "Add another",
                        title: 'Pension Annuities',
                        validationMessage: 'Enter details of at least one pension annuity'
                      },
                      {
                        key: 'person.income.hasPrivatePension',
                        title: 'Are you in receipt of private/works pension(s)?',
                        description: 'This is the amount you receive after deductions and taxes have been taken off. You will find this figure on your pension statement or cheque. If your pension is paid directly into a bank account, this figure will be shown on your bank statement.'
                      },
                      {
                        key: 'person.income.privatePensions',
                        condition: 'model.person.income.hasPrivatePension',
                        add: "Add another",
                        title: 'Private/Works Pensions',
                        validationMessage: 'Enter details of at least one private/works pension'
                      },
                      {
                        key: 'person.income.hasUnaccessedPension',
                        title: 'Do you have any pensions/pension pots/plans or annuities that are due to start in the next 12 months?'
                      },
                      {
                        key: 'person.income.unaccessedPensions',
                        condition: 'model.person.income.hasUnaccessedPension',
                        add: "Add another",
                        title: 'Future Pensions',
                        validationMessage: 'Enter details of at least one unaccessed pension'
                      },
                      {
                        key: 'person.income.hasDeferredPension',
                        title: 'Do you have any pensions/pension pots/plans or annuities that have been deferred?',
                        description: 'A pension deferral means that you have delayed claiming, or have stopped your pension, until a time that suits you. However, we still need to take this into account when calculating your care contribution'
                      },
                      {
                        key: 'person.income.deferredPensions',
                        condition: 'model.person.income.hasDeferredPension',
                        add: "Add another",
                        title: 'Deferred Pensions',
                        validationMessage: 'Enter details of at least one deferred pension'
                      },
                      {
                        key: 'person.details.transferHalfPensionToPartner',
                        title: 'Disregard half pension and transfer to partner?',
                        description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_CA/templates/transferHalfPensionToPartner.html'),
                        condition: 'model.person.details.hasPartner'
                      }
                    ]
                  },
                  {
                    type: "fieldset",
                    title: "Your partner's income",
                    htmlClass: "col-md-6",
                    items: [
                      {
                        type: "help",
                        helpvalue: "<h4 class='section-title'>Your partner's pensions</h4>"
                      },
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'partner.income.sources.retirementPensionReceived'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({
                        key: 'partner.income.sources.retirementPension',
                        htmlClass: 'invisible'
                      }, {
                        htmlClass: 'invisible'
                      }),
                      {
                        key: 'partner.income.hasPrivatePension',
                        title: 'Is your partner in receipt of private/works pension(s)?',
                        description: "This is the amount your partner receives after deductions and taxes have been taken off. Your partner will find this figure on their pension statement or cheque. If your partner's pension is paid directly into their bank account, this figure will be shown on their bank statement."
                      },
                      {
                        key: 'partner.income.privatePensions',
                        condition: 'model.partner.income.hasPrivatePension',
                        add: "Add more",
                        title: 'Private/Works Pensions',
                        validationMessage: 'Enter details of at least one private/works pension'
                      }
                    ],
                    condition: 'model.person.details.hasPartner && model.person.details.declarePartnerFinances'
                  }
                ]
              },
              {
                type: 'section',
                htmlClass: "row",
                items: [
                  {
                    type: "fieldset",
                    title: 'Universal Credit',
                    htmlClass: "col-md-6",
                    items: [
                      {
                        key: 'person.income.hasUniversalCredit',
                        title: 'Are you in receipt of Universal Credit?',
                        description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_FCA/templates/universalCreditGuidance.html'),
                        condition: '!model.partner.income.hasUniversalCredit'
                      },
                      fieldDefinitionService.boolean.noRequiredForm({
                        key: 'person.income.hasUniversalCredit',
                        title: 'Are you in receipt of Universal Credit?',
                        description: 'Universal Credit can be claimed either by you or your partner',
                        condition: 'model.partner.income.hasUniversalCredit'
                      }),
                      {
                        key: 'person.income.universalCredit',
                        notitle: true,
                        title: 'Universal Credit Allowances',
                        condition: 'model.person.income.hasUniversalCredit'
                      }
                    ]
                  },
                  {
                    type: "fieldset",
                    title: "Partner's Universal Credit",
                    htmlClass: "col-md-6",
                    condition: 'model.person.details.hasPartner',
                    items: [
                      {
                        key: 'partner.income.hasUniversalCredit',
                        title: 'Is your partner in receipt of Universal Credit?',
                        description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_FCA/templates/universalCreditGuidance.html'),
                        condition: '!model.person.income.hasUniversalCredit'
                      },
                      fieldDefinitionService.boolean.noRequiredForm({
                        key: 'partner.income.hasUniversalCredit',
                        title: 'Is your partner in receipt of Universal Credit?',
                        description: 'Universal Credit can be claimed either by you or your partner',
                        condition: 'model.person.income.hasUniversalCredit'
                      }),
                      {
                        key: 'partner.income.universalCredit',
                        notitle: true,
                        title: 'Universal Credit Allowances',
                        condition: 'model.partner.income.hasUniversalCredit'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'section',
                htmlClass: "row",
                items: [
                  {
                    type: "fieldset",
                    title: 'Your benefits',
                    htmlClass: "col-md-6",
                    items: [
                      fieldDefinitionService.groups.paymentFormField({
                        key: 'person.income.sources.attendanceAllowance',
                        condition: conditions.toString('person.income.sources.attendanceAllowance')
                      }),
                      fieldDefinitionService.groups.paymentFormField({
                        key: 'person.income.sources.dlaCare',
                        condition: conditions.toString('person.income.sources.dlaCare')
                      }),
                      fieldDefinitionService.groups.paymentFormField({
                        key: 'person.income.sources.pipDailyLiving',
                        condition: conditions.toString('person.income.sources.pipDailyLiving')
                      }),

                      fieldDefinitionService.groups.paymentFormField({key: 'person.income.sources.mobilityAllowance'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.incapacityBenefit'}),

                      fieldDefinitionService.groups.periodicJointPaymentFormFields({key: 'person.income.sources.employmentSupport'}, {}, {
                        condition: 'model.person.details.hasPartner'
                      }),
                      fieldDefinitionService.groups.periodicJointPaymentFormFields({ key: 'person.income.sources.incomeSupportPayment' }, {}, {
                        condition: 'model.person.details.hasPartner'
                      }),
                      fieldDefinitionService.groups.periodicJointPaymentFormFields({key: 'person.income.sources.jobSeekersAllowance'}, {}, {
                        condition: 'model.person.details.hasPartner'
                      }),
                      {
                        key: 'person.income.sources.workingAgeBenefitsIncludePremia',
                        condition: 'model.person.income.sources.employmentSupport || model.person.income.sources.incomeSupportPayment || model.person.income.sources.jobSeekersAllowance'
                      },

                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.maternityAllowance'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.exceptionalSevereDisablement'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.severeDisablement'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.workingTaxCredit'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.childTaxCredit'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.industrialInjuriesBenefit'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.warPension'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.warWidowsPension'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.armedForcesPayment'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.warSpecialPayment'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.carersAllowance'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.childBenefit'}),
                      fieldDefinitionService.groups.periodicJointPaymentFormFields({
                        key: 'person.income.sources.housingBenefit',
                        condition: "model.person.details.propertyTenancy !== 'ownedByYou'",
                      }, {}, {
                        condition: 'model.person.details.hasPartner'
                      }),
                      fieldDefinitionService.groups.periodicJointPaymentFormFields({
                        key: 'person.income.sources.pensionGuaranteeCredit',
                        description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_FCA/templates/pensionCredit.html')
                      }, {}, {
                        condition: 'model.person.details.hasPartner'
                      }),
                      {
                        key: 'person.income.sources.pensionAgeBenefitsIncludePremia',
                        condition: 'model.person.income.sources.pensionGuaranteeCredit'
                      },

                      fieldDefinitionService.groups.periodicJointPaymentFormFields({key: 'person.income.sources.pensionSavingsCredit'}, {}, {
                        condition: 'model.person.details.hasPartner'
                      }),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.otherBenefit'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.wages'})
                    ]
                  },
                  {
                    type: "fieldset",
                    title: "Your partner's benefits",
                    htmlClass: "col-md-6",
                    items: [
                      fieldDefinitionService.groups.paymentFormField({key: 'partner.income.sources.attendanceAllowance'}),
                      fieldDefinitionService.groups.paymentFormField({key: 'partner.income.sources.dlaCare'}),
                      fieldDefinitionService.groups.paymentFormField({key: 'partner.income.sources.mobilityAllowance'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'partner.income.sources.incapacityBenefit'}),

                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'partner.income.sources.employmentSupport'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'partner.income.sources.incomeSupportPayment'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'partner.income.sources.jobSeekersAllowance'}),

                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'partner.income.sources.warPension'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'partner.income.sources.warSpecialPayment'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'partner.income.sources.carersAllowance'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'partner.income.sources.childBenefit'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'partner.income.sources.otherBenefit'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'partner.income.sources.wages'})
                    ],
                    condition: 'model.person.details.hasPartner && model.person.details.declarePartnerFinances'
                  }
                ]
              },

              {
                type: 'section',
                htmlClass: "row",
                items: [
                  {
                    type: "fieldset",
                    title: 'Your other income',
                    htmlClass: "col-md-6",
                    items: [
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.rentalIncome'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.annuitiesIncome'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.trustFunds'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.maintenance'}),
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'person.income.sources.otherIncome'})
                    ]
                  },
                  {
                    type: "fieldset",
                    title: "Your partner's other income",
                    htmlClass: "col-md-6",
                    items: [
                      fieldDefinitionService.groups.periodicPaymentFormFields({key: 'partner.income.sources.otherIncome'})
                    ],
                    condition: 'model.person.details.hasPartner && model.person.details.declarePartnerFinances'
                  }
                ]
              },
              {
                type: 'section',
                htmlClass: "row",
                items: [
                  {
                    type: "fieldset",
                    title: 'Personal Injury Claim',
                    htmlClass: "col-md-12",
                    items: [
                      {
                        key: 'person.personalInjury.hasReceivedCompensation',
                        title: 'Have you received compensation for any form of personal injury?',
                      },
                      {
                        key: 'person.personalInjury.details',
                        condition: 'model.person.personalInjury.hasReceivedCompensation',
                        title: 'Please give more details about this award and where the monies are held. You will also need to provide a copy of the award.'
                      }
                    ]
                  }
                ]
              },
              {
                type: 'section',
                htmlClass: "row",
                items: [
                  {
                    type: "fieldset",
                    title: 'Private Health Insurance/Hospital Fund Scheme',
                    htmlClass: "col-md-12",
                    items: [
                      {
                        key: 'person.healthInsurance.hasInsurance',
                        title: 'Do you have Private Health Insurance which covers you for Home Care or Residential Care?',
                        description: 'If you have Private Insurance or hospital fund scheme you may be asked to contribute the full amount of any payment you receive towards the service provided.'
                      },
                      {
                        key: 'person.healthInsurance.details',
                        condition: 'model.person.healthInsurance.hasInsurance',
                        notitle: true
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: 'section',
            condition: 'model.page === 5',
            page: 5,
            items: [
              'person.details.heatingType',
              {
                key: 'person.details.otherHeatingType',
                condition: 'model.person.details.heatingType === "other"'
              },
              {
                type: 'section',
                htmlClass: "row",
                items: [
                  {
                    type: "fieldset",
                    title: 'Your payments and outgoings',
                    htmlClass: "col-md-6",
                    items: [
                      {
                      type: 'template',
                      htmlClass: 'divTitle',
                      templateUrl: 'modules/forms/scripts/services/forms/LI_FCA/templates/cfa_animation_05_outgoings-intro.html'
                      },
                      fieldDefinitionService.groups.periodicPaymentFormFields({
                        key: 'person.expenses.compulsoryPayments',
                        description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_CA/templates/courtOrderedPayments.html')
                      }),
                      fieldDefinitionService.groups.paymentFormField({
                        key: 'person.expenses.councilTax',
                      }),
                      {
                        type: 'template',
                        htmlClass: 'divTitle',
                        templateUrl: 'modules/forms/scripts/services/forms/LI_CA/templates/annualCouncilTaxDescription.html'
                      },
                      'person.expenses.howCouncilTaxIsPaid',
                      fieldDefinitionService.groups.periodicPaymentFormFields({
                        key: 'person.expenses.rent',
                        description: "<p>Enter the total amount of rent, as shown on your tenancy agreement or most recent rent letter.</p><p><strong>Please note:</strong> If you are paying rent to a family member that you live with and there is no formal rental agreement in place, this amount will be disregarded from the calculation so you should <strong>not</strong> enter it here.</p>"
                      }),
                      fieldDefinitionService.groups.periodicPaymentFormFields({
                        key: 'person.expenses.mortgage',
                        condition: conditions.toString('person.expenses.mortgage')
                      }),
                      fieldDefinitionService.groups.periodicPaymentFormFields({
                        key: 'person.expenses.mortgageInsurance',
                        condition: conditions.toString('person.expenses.mortgage'),
                        description: "For any endowment/life insurance policies then these have to be directly linked to your mortgage (i.e. it can't be stand alone life insurance). We may ask you for evidence of this."
                      }),
                      fieldDefinitionService.groups.periodicPaymentFormFields({
                        key: 'person.expenses.homeInsurance',
                        description: "<p>If you have a combined buildings and contents insurance policy, enter the total amount you pay.</p><p><strong>Please note:</strong> Building insurance details are only required on the property that you currently reside in (or for your former home if you still own it but are now residing in a care home setting). Insurance details are not required on rented property.</p>"
                      }),
                      {
                        key: 'person.expenses.isHomeInsuranceCombined',
                        condition: 'model.person.expenses.homeInsurance'
                      },
                      fieldDefinitionService.groups.periodicPaymentFormFields({
                        key: 'person.expenses.groundRent',
                      })

                    ].concat(residentialExpenses())
                  },
                  {
                    type: "fieldset",
                    condition: 'model.person.details.hasPartner && model.person.details.declarePartnerFinances',
                    title: "Your partner's payments and outgoings",
                    htmlClass: "col-md-6",
                    items: [
                      fieldDefinitionService.groups.periodicPaymentFormFields({
                        key: 'partner.expenses.compulsoryPayments',
                        description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_CA/templates/courtOrderedPayments.html')
                      })
                    ]
                  }
                ]
              }
            ]
          },
          {
            type: 'fieldset',
            condition: 'model.page === 6',
            page: 6,
            items: [
              {
                type: "fieldset",
                title: 'Capital - Transfers and Gifting',
                items: [
                  {
                    type: 'template',
                    htmlClass: 'divTitle',
                    templateUrl: 'modules/forms/scripts/services/forms/LI_FCA/templates/cfa_animation_12_capital_transfers-gifting-intro.html'
                  },
                  'longTermResidents.deprivationOfAssets.hasDisposedOfAssets',
                  {
                    key: 'longTermResidents.deprivationOfAssets.disposedAssets',
                    title: false,
                    condition: 'model.longTermResidents.deprivationOfAssets.hasDisposedOfAssets',
                    validationMessage: 'Enter details of at least one asset'
                  },
                  {
                    type: "template",
                    templateUrl: "modules/forms/scripts/services/forms/LI_FCA/templates/transferredAssets.html",
                    condition: 'model.longTermResidents.deprivationOfAssets.hasDisposedOfAssets'
                  },
                  {
                    title: "Authority to obtain information",
                    key: 'longTermResidents.deprivationOfAssets.advisor',
                    condition: 'model.longTermResidents.deprivationOfAssets.hasDisposedOfAssets'
                  }
                ]
              },
              {
                type: "fieldset",
                title: 'Capital Assets',
                items: [
                  'longTermResidents.businessOwnership.hasBusinessInterests',
                  {
                    title: false,
                    key: 'longTermResidents.businessOwnership.business',
                    condition: 'model.longTermResidents.businessOwnership.hasBusinessInterests'
                  }
                ]
              }
            ]
          },
          {
            type: 'fieldset',
            condition: 'model.page === 7',
            page: 7,
            title: 'Cost of care',
            items: costOfCareItems(),
          },
          {
            type: 'fieldset',
            condition: 'model.page === 8',
            page: 8,
            title: 'How to make your contribution for care',
            items: [
              {
                key: 'careAssessment.paymentMethod',
                description: htmlService.interpolateTemplate('modules/forms/scripts/services/forms/LI_FCA/templates/paymentMethodDescription.html')
              }
            ]
          },
          {
            type: 'fieldset',
            condition: 'model.page === 9',
            page: 9,
            title: "Filling in the form on someone else's behalf",
            items: [
              {
                type: 'template',
                htmlClass: 'divTitle',
                templateUrl: 'modules/forms/scripts/services/forms/LI_FCA/templates/cfa_animation_07_advocate-intro.html'
              },
              'agent.isCompletedByAgent',
              {
                key: 'agent.reason',
                condition: 'model.agent.isCompletedByAgent'
              },
              {
                key: 'agent.details',
                condition: 'model.agent.isCompletedByAgent',
                title: 'Details of the person who filled the form'
              },
              {
                key: 'agent.applicantConfirmationDeclaration',
                validationMessage: 'You must agree to this declaration',
                condition: conditions.toString('agent.applicantConfirmationDeclaration')
              },
              {
                key: 'agent.agentDeclaration',
                validationMessage: 'You must agree to this declaration',
                condition: conditions.toString('agent.agentDeclaration')
              },
              {
                type: "fieldset",
                title: "Declaration and Undertaking",
                items: [
                  {
                    type: "template",
                    templateUrl: "modules/forms/scripts/services/forms/LI_FCA/templates/declaration.html"
                  },
                  {
                    key: 'declaration.isAccepted',
                    description: 'Please type your full name into the box.',
                    validationMessage: 'You must indicate that you agree to and understand the above declaration'
                  }
                ]
              }
            ]
          },
          {
            type: 'fieldset',
            condition: 'model.page === 10',
            page: 10,
            title: "Letter of Authority",
            items: [
              {
                type: "template",
                templateUrl: "modules/forms/scripts/services/forms/LI_FCA/templates/letterOfAuthority.html"
              },
              'letterOfAuthority.isPersonNominated',
              {
                type: 'fieldset',
                title: 'Details of nominated person or agency',
                condition: 'model.letterOfAuthority.isPersonNominated',
                items: [
                  'letterOfAuthority.nominatedPersonDetails.name',
                  'letterOfAuthority.nominatedPersonDetails.phoneNumber',
                  'letterOfAuthority.nominatedPersonDetails.emailAddress',
                  'letterOfAuthority.nominatedPersonDetails.relationship'
                ]
              },
              {
                key: 'letterOfAuthority.permitDiscussion',
                validationMessage: 'You must agree to this declaration',
                condition: 'model.letterOfAuthority.isPersonNominated'
              },
              {
                key: 'letterOfAuthority.permitCorrespondence',
                condition: 'model.letterOfAuthority.isPersonNominated'
              },
              {
                type: 'fieldset',
                title: 'Address of nominated person or agency',
                condition: 'model.letterOfAuthority.isPersonNominated && model.letterOfAuthority.permitCorrespondence',
                items: [
                  'letterOfAuthority.nominatedPersonDetails.addressLine1',
                  'letterOfAuthority.nominatedPersonDetails.addressLine2',
                  'letterOfAuthority.nominatedPersonDetails.addressLine3',
                  'letterOfAuthority.nominatedPersonDetails.postcode'
                ]
              }
            ]
          },
          {
            type: "section",
            condition: "areFormNavigationButtonsVisible()",
            items: [
              {
                type: "actions",
                htmlClass: "formPaginationButtons",
                items: [
                  {
                    type: "button",
                    style: "btn-default",
                    title: "Previous",
                    onClick: "prev()"
                  },
                  {
                    type: "button",
                    style: "btn-primary",
                    title: "Next",
                    onClick: "next()"
                  }]
              }
            ]
          }
        ]);

        return formUI;
      }]);
